<div>
  <ngx-editor-menu [editor]="editor"
                   [toolbar]="toolbar"> </ngx-editor-menu>
  <ngx-editor [editor]="editor"
              [ngModel]="value"
              (ngModelChange)="modelChanged($event)"
              [disabled]="isDisabled"
              [placeholder]="'Type here...'"></ngx-editor>
</div>
